import { DialogContent } from '@material-ui/core';

const infoContent = `
<div style="font-family: 'Montserrat-Regular'; font-size: 14px;">
    <p style="padding: 8px 0;">
        <b>To locate your inactive folios, please follow these steps:</b>
    </p>

    <p style="padding: 8px 0;">
        <b>Step 1</b>: Enter Investor's Name (Mandatory)
    </p>

    <p style="padding: 8px 0;">
        <b>Step 2</b>: Provide one key identification detail (PAN, PEKRN, Email, Mobile Number, Date of Birth, or Bank Account Number)
    </p>

    <p style="padding: 8px 0;">
        <b>Step 3</b>: Provide one additional detail (Address, Pincode, City, or Nominee Name)
    </p>

    <p style="padding: 8px 0;">
        If you do not have a key identification detail, select "None" and provide three additional details instead.
    </p>

    <p style="padding: 8px 0;">
        Optional: Enter your Folio Number and AMC Name to expedite the search process.
    </p>

    <p style="padding: 8px 0;">
        Initiate your search now and seamlessly retrieve your inactive investments.
    </p>
</div>`;

export const InactiveFoliosInfo = () => (
    <DialogContent>
        <div dangerouslySetInnerHTML={{ __html: infoContent }} />
    </DialogContent>
);
